const SubmitEPOD = (props) => {
    const handleClick = (e) => {
        e.stopPropagation();
        props.onShowSubmitEPOD(props);
    };
    {
        if (props.value != undefined && props.value != '' && props.value == 1)
            return <></>
        else
            return <a href="javascript:;" className="label-warning f12" style={{ color: "#333", padding: "2px 10px" }} onClick={handleClick}>Submit e-POD</a>
    }
}
export default SubmitEPOD